import React, {FunctionComponent, useMemo} from 'react';
import ServerTable, {TableHeadActionsProps} from "../../ServerTable";
import {TableColumn} from "../../../../models/Table";
import {Link} from 'react-router-dom';
import { Client } from '../../../../models/Client';
import ClientService from '../../../../services/ClientService';

export default () => {
    const tableService = new ClientService()
    const columns = useMemo<TableColumn<Client>[]>(() => [
        {
            Header: 'Nazwa',
            accessor: ({full_name}) => full_name,
            sortBy: 'number'
        },
        {
            Header: 'Opcje',
            accessor: ({id}) => <Link to={`/admin/clients/${id}`}>
                <button className="btn btn-sm btn-primary">Edytuj</button>
            </Link>,
            sortBy: ''
        },
    ], [])

    const header: FunctionComponent<TableHeadActionsProps> = ({onInput}) =>
        <div className="input-group">
            <input className="form-control" type="text" placeholder="Szukaj..." aria-label="Szukaj..."
                onChange={e => {
                    onInput({query: e.target.value})
                }}/>
            <Link to={`/admin/clients/add`}>
                <button className="btn btn-lg btn-primary">Dodaj nowy</button>
            </Link>
        </div>

    return <ServerTable<Client> tableService={tableService} columns={columns}>
        {{header}}
    </ServerTable>
}